@let notificationCount = notificationCount$ | async;
@let userIdForNotifications = userIdForNotifications$ | async;

<div class="notification-panel">
  <div class="notification-panel_title">
    <p>{{ 'NOTIFICATIONS' | translate }}</p>
    <button (click)="markedAll()" mat-button class="actions-marked">
      {{ 'MARK ALL AS READ' | translate }}
    </button>
  </div>
  <div class="notification-panel_actions">
    <div class="actions--filter">
      <button
        [ngClass]="{ active: isActiveFilterType }"
        (click)="filterBy(true, userIdForNotifications!)"
        class="actions-btn">
        {{ 'ALL' | translate }}
      </button>

      <button
        [ngClass]="{ active: !isActiveFilterType }"
        (click)="filterBy(false)"
        class="actions-btn">
        {{ 'UNREAD' | translate }} <span>({{ notificationCount }})</span>
      </button>
    </div>
  </div>
  <div class="notification-panel_content">
    @if (notificationsLists?.length) {
      <cdk-virtual-scroll-viewport
        minBufferPx="540"
        maxBufferPx="1200"
        itemSize="227"
        class="lists">
        <app-notification-card
          *cdkVirtualFor="let notification of notificationsLists"
          [notification]="notification"
          (deleteNotification)="deleteNotification($event)"
          (notificationViewed)="markAsViewed($event)"></app-notification-card>
      </cdk-virtual-scroll-viewport>
    } @else {
      <div class="notification-attention">
        <nav class="not-access-image">
          <img src="assets/svg/logo.svg" alt="Neolink" />
        </nav>
        <h3 class="not-access-title text">
          {{ 'NOTIFICATION NOT FOUND' | translate }}
        </h3>
      </div>
    }
  </div>
  <div class="notification-panel_footer">
    <button mat-button routerLink="/notifications" (click)="closePanel.emit()">
      {{ 'SEE ALL NOTIFICATIONS' | translate }}
    </button>
  </div>
</div>
<div class="notification-overlay" (click)="closePanel.emit()"></div>
